import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

import { ApiChatMetadata, chatApi, transformApiChatMetadata, useApiClient } from "../../api";
import { QUERY_KEYS } from "../../constants";

export const useChatMetadata = () => {
  const apiClient = useApiClient();

  const fetchMetadata = useCallback(async () => {
    const response = await chatApi.getChatMetadata(apiClient);
    const apiMetadata = response.data as ApiChatMetadata;
    return transformApiChatMetadata(apiMetadata);
  }, [apiClient]);

  return useQuery({
    queryKey: QUERY_KEYS.chatMetadata(),
    queryFn: fetchMetadata,
    staleTime: 5 * 60 * 1000, // 5 minutes - metadata doesn't change often
  });
};
